import { ROUTES } from '@/config/routes';

export const DASHBOARD_SIGNUP_URL = 'https://dashboard.boxdlogistics.com/sign-up';
export const DASHBOARD_SIGNIN_URL = 'https://dashboard.boxdlogistics.com/sign-in';
export const TRACKING_URL = ROUTES.TRACK_ORDER;
export const SHOPIFY_APP_URL = DASHBOARD_SIGNUP_URL;
export const INSTAGRAM_URL = 'https://www.instagram.com/boxdlogistics/';
export const YOUTUBE_URL = 'https://www.youtube.com/@Boxdlogistics';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/boxd-logistics/';
export const CONTACT_ROUTE = ROUTES.CONTACT;
export const SUPPORT_EMAIL = 'info@boxdlogistics.in';
export const SUPPORT_EMAIL_MAILTO = `mailto:${SUPPORT_EMAIL}`;
export const SUPPORT_PHONE_PRIMARY_DISPLAY = '+91 9216058358';
export const SUPPORT_PHONE_PRIMARY_TEL = '+919216058358';
export const SUPPORT_PHONE_DUMMY_DISPLAY = '+91 9216058358';
export const SUPPORT_PHONE_DUMMY_TEL = '+919216058358';
export const GURUGRAM_MAPS_URL =
  'https://maps.google.com/?q=8th+Floor+Magnum+Tower+Sector+58+Golf+Course+Extension+Road+Gurugram+Haryana+122011';
